(function (angular, app) {
    "use strict";

    angular.module(app.modules.scoring.name)
       .factory(app.modules.scoring.services.gamescore, GameScoreFactory);

    GameScoreFactory.$inject = [app.modules.common.services.http
        , app.modules.common.constants.appsettings
        , app.modules.common.services.functions
    ];

    function GameScoreFactory($http
        , ggSettings
        , ggFunctions
        ) {

        var search = {

        }

        var score = {
            game: {
                fetchGame: function (data) {
                    var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games;
                    apipath = apipath.replace("(id)", "(" + data.outingId + ")");
                    var qry = "?$filter=isMain eq true";
                    var exp = "&$expand=outing($select=name,startOn,endOn,themeId)";
                    return $http.get(apipath + qry + exp, {});
                }
            }
           , course: {
               fetchGameCourse: function (data) {
                   var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.courses + "(" + data.gameCourseId + ")";
                   apipath = apipath.replace("(id)", "(" + data.outingId + ")");
                   var qry = "";
                   var exp = "?$expand=gameTees($expand=gameHoles)"
                   return $http.get(apipath + qry + exp, {});
               }
           }
           , round: {
               fetchTeeTime: function (data) {
                   var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes + "(" + data.teeTimeId + ")";
                   apipath = apipath.replace("(id)", "(" + data.outingId + ")");
                   var qry = "";
                   var exp = "?$expand=teams,players($select=id,teamId,teamOrder,handicap,effectiveOn,handicapType;$expand=member($select=id,firstName,lastName,gender))"
                   return $http.get(apipath + qry + exp, {});
               }

           }
           , holes: {
               fetchGameHoleScores: function (gameScoreId) {
                   var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.gameHoleScores;
                   var qry = "?$filter=gameScoreId eq " + gameScoreId;
                   var exp = ""
                   // Post the data, but don't transform it.
                   return $http.get(apipath + qry + exp, {});
               }
           }
           , fetchScoreSimple: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameScores;
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");
               var qry = "?$filter=id eq " + data.gameScoreId;
               var exp = "&$expand=teeTime";
               return $http.get(apipath + qry + exp, {});
           }
          , fetchTeeTimeDetail : function(data){
              var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameScoreByTeeTime;
              apipath = apipath.replace("{outingId}",  data.outingId );
              apipath = apipath.replace("{teeTimeId}",  data.teeTimeId );
              // Post the data, but don't transform it.
              return $http.get(apipath, {});
           }
           , fetchGameScoreDetail: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameScores;
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");
               var qry = "(" + data.gameScoreId + ")";
               qry += "?$expand=gameHoleScores"
               //qry += "/getGameScoreInfo"; // "?$filter=id eq " + data.gameScoreId
               var exp = ""; //"&$expand=gameTee($expand=gameHoles),gameHoleScores,player($expand=member)";
               //var exp = "&$expand=gameTee($expand=gameHoles),teeTime,gameHoleScores,player($expand=member)";
               //var exp = "&$expand=gameTee($expand=gameHoles),teeTime($expand=gameCourse($expand=gameTees),round),gameHoleScores";
               // Post the data, but don't transform it.
               return $http.get(apipath + qry + exp, {});
           }
           , fetchGameScores: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameScores;
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");
               var qry = "?$filter=teeTimeId eq " + data.teeTimeId;
               var exp = ""
               if (data.playerId && !data.isTeamScore) {
                   qry += " and playerId eq " + data.playerId;
               }
               if (data.teamId) {
                   qry += " and teamId eq " + data.teamId;
               }
               var exp = "";
               // Post the data, but don't transform it.
               return $http.get(apipath + qry + exp, {});
           }
           , insertGameScore: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameScores;
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");

               var form = {};
               form.teeTimeId = data.teeTimeId;
               form.playerId = data.playerId;
               form.createdById = app.Member.Detail.id;
               //if (data.gameTeeId && data.gameTeeId > 0) {
               form.gameTeeId = data.gameTeeId || null;
               //}
               if (data.teamId && data.teamId > 0) {
                   form.teamId = data.teamId || null;
               }
               // if (data.isTeamScore) {
               form.isTeamScore = data.isTeamScore || false;
               //}


               // Post the data, but don't transform it.
               return $http.post(apipath, form, false);
           }
           , updateGameScore: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameScores + "(" + data.id + ")";
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");

               var form = {
                   updatedById: app.Member.Detail.id
               }
               if (data.gameTee) {
                   form.gameTeeId = data.gameTee.id;
               }
               if (!data.isTeamScore) {
                   form.playerId = data.playerId;
               } else {
                   form.teamId = data.teamId;
               }
               if (data.isTeamScore) {
                   form.isTeamScore = data.isTeamScore;
               }
               if (data.teeTime) {
                   form.teeTimeId = data.teeTime.id;
               }
               if (data.gross) {
                   form.gross = data.gross;
               }
               if (data.net) {
                   form.net = data.net;
               }
               if (data.front9Gross) {
                   form.front9Gross = data.front9Gross;
               }
               if (data.front9Net) {
                   form.front9Net = data.front9Net;
               }
               if (data.back9Gross) {
                   form.back9Gross = data.back9Gross;
               }
               if (data.back9Net) {
                   form.back9Net = data.back9Net;
               }
               if (data.scoredThru) {
                   form.scoredThru = data.scoredThru;
               }
               if (data.stats) {
                   form.stats = data.stats;
               }
               if (data.wagers) {
                   form.wagers = data.wagers;
               }

               // Post the data, but don't transform it.
               return $http.put(apipath, form);
           }
           , updateGameHoleScore: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameHoleScores + "(" + data.id + ")";
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");
               var form = {
                   gameScoreId: data.gameScoreId
                  , holeNumber: data.holeNumber
                  , gross: data.gross
                  , stats: data.stats
               }
               if (data.wagers) {
                   if (data.wagers.value1) {
                       form.wagers = data.wagers
                   }
               }
               // Post the data, but don't transform it.
               return $http.put(apipath, form);
           }
           , insertGameHoleScore: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.scoring.gameHoleScores;
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");
               var form = {
                   gameScoreId: data.gameScoreId
                  , holeNumber: data.holeNumber
                  , gross: data.gross
                  , stats: data.stats
               }
               if (data.wagers) {
                   if (data.wagers.value1) {
                       form.wagers = data.wagers
                   }

               }
               // Post the data, but don't transform it.
               return $http.post(apipath, form, false);
           }
           , batchGameScore: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.batchPost;
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");
               apipath = apipath.replace("(teeTimeId)", "(" + data.teeTime.id + ")");

               // The rpoblem with this data is wagers.
               var tmp = data;
               var ary = [];
               for (var t = 0; t < data.scores.length; t++) {
                   var s = {
                       id: data.scores[t].id
                      , gross: data.scores[t].net
                      , net: data.scores[t].net
                       //, isComplete: data.scores[t].isComplete
                      , isTeamScore: data.scores[t].isTeamScore
                       //, toPar: data.scores[t].toPar
                      , scoredThru: data.scores[t].scoredThru
                      , playerId: data.scores[t].playerId
                      , teamId: data.scores[t].teamId
                      , gameTeeId: data.scores[t].gameTeeId
                      , front9Net: data.scores[t].front9Net
                      , back9Net: data.scores[t].back9Net
                      , front9Gross: data.scores[t].front9Gross
                      , back9Gross: data.scores[t].back9Gross
                      , updatedById: data.scores[t].updatedById
                      , gameHoleScores: data.scores[t].gameHoleScores
                      , stats: data.scores[t].stats
                      , wagers: data.scores[t].wagers
                      , teeTimeId: data.scores[t].teeTimeId
                      , scoreStatus : data.scores[t].scoreStatus
                   }
                   if (s.gameHoleScores && s.gameHoleScores.length > 0) {
                       for (var h = 0; h < s.gameHoleScores.length; h++) {
                           if (s.gameHoleScores[h].isChanged) {
                               delete s.gameHoleScores[h].isChanged;
                           }
                           if (s.gameHoleScores[h].wagers) {
                               if (!s.gameHoleScores[h].wagers.value1) {
                                   delete s.gameHoleScores[h].wagers;
                               }
                           }
                       }
                   }
                   ary.push(s);
               }

               var form = {
                   scores: ary
               }


               // Post the data, but don't transform it.
               return $http.post(apipath, form, false);
           }
           , postScoreToHandicap: function (scoreId) {
               var
                   root = ggSettings.grpapi.root,
                   data = { scoreId: scoreId },
                   url = root + 'postScoreToHandicap';

               return $http.post(url, data);
           }
        }

        var service = {
            search: search
           , score: score
        }

        return service;
    }
}(angular, app));

